/* Appends the passed css to the head of the document
 * It automatically creates the style tag and appends to the head tag in the dom
 * This is a decorator class and should be used as @injectCss(<cssString>)
 * This decorator should sit directly above the @customElement decorator
 */
export const injectCss = (css) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (target) => {
        const head = document.head || document.getElementsByTagName('head')[0];
        const styleTag = document.createElement('style');
        styleTag.appendChild(document.createTextNode(css));
        head.appendChild(styleTag);
        return target;
    };
};
//# sourceMappingURL=inject-css.js.map